// extracted by mini-css-extract-plugin
export default {"main":"Actions_main__GWAqX","text":"Actions_text__arvtx","actions":"Actions_actions__W+tr+","reserve-pop":"Actions_reserve-pop__OLeeO","pop":"Actions_pop__qYaZz"};